/* eslint-disable prettier/prettier */
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// Icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Custom components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Layout & image
import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/bg-sign-in-basic.jpg";

// Auth context
import { useAuth } from "../../../context/AuthContext";

function Basic() {
    const [confirmPassword, setConfirmPassword] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const { auth, setIsAuthenticated } = useAuth();
    const navigate = useNavigate();


    const handleCompletePassword = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        if (password.length < 8 || confirmPassword.length < 8) {
            setError("The password must contain a minimum of 8 characters");
            setLoading(false);
            return 0;
        } else {
            if (password === confirmPassword) {
                const result = await auth.completePassword(password);
                if (result.success === true) {
                    setIsAuthenticated(true);
                    navigate("/dashboard");
                } else {
                    setError(result.errorMessage);
                }
            } else {
                setError("Please double-check your password.");
                setLoading(false);
            }

        }

        setLoading(false);
    };

    return (
        <BasicLayout image={bgImage}>
            <Card>
                <MDBox
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                    mx={2}
                    mt={-3}
                    p={2}
                    mb={1}
                    textAlign="center"
                >
                    <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                        New Password Required
                    </MDTypography>

                </MDBox>
                <MDBox pt={4} pb={3} px={3}>
                    <MDBox component="form" role="form" onSubmit={handleCompletePassword}>
                        <MDBox mb={2}>
                            <MDInput
                                type="password"
                                label="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                fullWidth
                                required
                            />

                        </MDBox>
                        <MDBox mb={2}>
                            <MDInput
                                type="password"
                                label="Confirm Password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                fullWidth
                                required
                            />
                        </MDBox>

                        {error && (
                            <MDBox mt={2}>
                                <MDTypography variant="caption" color="error">
                                    {error}
                                </MDTypography>
                            </MDBox>
                        )}
                        <MDBox mt={4} mb={1}>
                            <MDButton type="submit" variant="gradient" color="info" fullWidth disabled={loading}>
                                {loading ? "Signing in..." : "Sign in"}
                            </MDButton>
                        </MDBox>

                    </MDBox>
                </MDBox>
            </Card>
        </BasicLayout>
    );
}

export default Basic;
